export default function() {
    return {
        roles: {
            'ROLE_CONTRACTOR': 'Contratante',
            'ROLE_PROFESSIONAL': 'Prestador'
        }
    }
}
